import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import QRCode from 'qrcode';
import SecurityService from '../../services/SecurityService';
import ConfigurationService from '../../services/ConfigurationService';
import Select from '../UI/Select';
import { startLoading, endLoading } from '../../actions/loadingAction';
import BaseComponent from '../BaseComponent';
import { checkPermission, getVision } from '../../services/auth';
import { PERMISSIONS, ENUMS, VISIONS } from '../../utils/constants';
import { getPathApp, isNullOrEmpty } from '../../utils/util';
import * as actionInventory from '../../actions/inventoryAction';
import * as linePickingAction from '../../actions/linePickingAction';
import * as pickingAction from '../../actions/pickingAction';
import * as actionUser from '../../actions/userAction';
import VolumeService from '../../services/VolumeService';
import UserValidateService from '../../services/UserValidateService';
import PhysicalConfirmationService from '../../services/PhysicalConfirmationService';
import PlantService from '../../services/PlantService';

class Menu extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
            infoUserMenu: 'expand_more'
        };
    }

    generateMenu = () => {
        const pathurl = getPathApp(window);
        let menu = [];

        menu = [...menu, (
            <Link to={`${pathurl}/home`} onClick={(evt) => {
                this.closeMenu(evt);
                setTimeout(() => {
                    window.location.reload(true)
                }, 800);
            }}>
                <i className="material-icons">home</i>
                {this.translate('menu:home')}
            </Link>)];

        if (checkPermission(PERMISSIONS.PhysicalConfirmation.Access)) {
            menu = [...menu, (
                <Link to={`${pathurl}/receipt/V2/receiptParameters`} onClick={(evt) => {
                    this.props.loadConfig(getVision(), ENUMS.eModules.PhysicalConfirmation.value);
                    this.props.loadConfigUser();
                    this.props.clearConfigurations();
                    this.props.resetResourceShedDock();
                    this.props.getResourcesAll();
                    this.props.clearPrintSelect();
                    this.closeMenu(evt);
                }}>
                    <i className="material-icons">assignment_turned_in</i>
                    {this.translate('menu:physical-confirmation')}
                </Link>)];
        }


        if (checkPermission(PERMISSIONS.TRUCK_KANBAN.Access)) {
            menu = [...menu, (
                <Link to={`${pathurl}/truckkanban/home`} onClick={(evt) => {
                    this.props.loadConfigUser();
                    this.props.getResourcesAll();
                    this.closeMenu(evt);
                }}> <i className="material-icons">'compare_arrows'</i>
                    {this.translate('physical-confirmation:xd-space')}
                </Link>)];
        }

        if (checkPermission(PERMISSIONS.Volume.Access) === true) {
            menu = [...menu, (
                <Link to={{ pathname: `${pathurl}/volume`, state: { table: 3 } }} onClick={(evt) => {
                    this.props.loadConfig(getVision(), ENUMS.eModules.Volume.value);
                    this.props.clearVolume();
                    this.props.resetResourceShedDock();
                    this.closeMenu(evt);
                }}>
                    <i className="mdi mdi-layers-triple-outline black-text"></i>
                    {this.translate('menu:volume')}
                </Link>)];

        }

        if (checkPermission(PERMISSIONS.Inventory.Access) === true) {
            menu = [...menu, (
                <Link to={`${pathurl}/inventory`} onClick={(evt) => {
                    this.props.loadConfigUser();
                    this.props.loadConfig(getVision(), ENUMS.eModules.Inventory.value);
                    this.closeMenu(evt);
                }}>
                    <i className="mdi mdi-clipboard-check-outline black-text" />
                    {this.translate('menu:inventory')}
                </Link>)];
        }

        if (checkPermission(PERMISSIONS.Expedition.Access) || checkPermission(PERMISSIONS.Expedition.PackList.Access)) {
            if (checkPermission(PERMISSIONS.Expedition.Picking.Filters) || checkPermission(PERMISSIONS.Expedition.PackList.Access)) {
                menu = [...menu, (
                    <Link to={`${pathurl}/expedition/picking`} onClick={(evt) => {
                        this.props.loadConfigUser();
                        this.props.loadConfig(getVision(), ENUMS.eModules.Picking.value);
                        this.props.getResourcesAll();
                        this.closeMenu(evt);
                    }}>
                        <i className="mdi mdi-dolly black-text" />
                        {getVision() !== VISIONS.Jeep ? this.translate('menu:picking') : this.translate('menu:pickingCT')}
                    </Link>)];
            } else {
                menu = [...menu, (
                    <Link to={`${pathurl}/expedition/picking/ondemand`} onClick={this.closeMenu}>
                        <i className="mdi mdi-dolly black-text" />
                        {getVision() !== VISIONS.Jeep ? this.translate('menu:picking') : this.translate('menu:pickingCT')}
                    </Link>)];
            }
        }

        if (checkPermission(PERMISSIONS.LinePicking.Access) || checkPermission(PERMISSIONS.Delivery.Access)) {
            menu = [
                ...menu,
                (
                    <Link to={`${pathurl}/linePicking`} onClick={(evt) => {
                        this.props.loadConfig(getVision(), ENUMS.eModules.LinePicking.value);
                        this.props.getResourcesAll();
                        this.props.loadConfigUser();
                        this.closeMenu(evt);
                    }}>
                        <i className="mdi mdi-timetable black-text" />
                        {this.translate('menu:line-picking')}
                    </Link>
                )
            ];
        }


        if (checkPermission(PERMISSIONS.Lowering.Access)) {
            menu = [
                ...menu,
                (
                    <Link to={`${pathurl}/lowering`} onClick={(evt) => {
                        this.props.loadConfig(getVision(), ENUMS.eModules.LinePicking.value);
                        this.props.getResourcesAll();
                        this.props.loadConfigUser();
                        this.closeMenu(evt);
                    }}>
                        <i className="mdi mdi-arrow-down black-text" />
                        {this.translate('menu:lowering')}
                    </Link>
                )
            ];
        }

        if (checkPermission(PERMISSIONS.PABReplanning.Access)) {
            menu = [
                ...menu,
                (
                    <Link to={`${pathurl}/pabReplanning`} onClick={(evt) => {
                        this.props.loadConfig(getVision(), ENUMS.eModules.LinePicking.value);
                        this.props.getResourcesAll();
                        this.props.loadConfigUser();
                        this.closeMenu(evt);
                    }}>
                        <i className="mdi mdi-refresh black-text" />
                        {this.translate('menu:pabReplanning')}
                    </Link>
                )
            ];
        }

        if (checkPermission(PERMISSIONS.LoadUnload.Access)) {
            menu = [...menu, (
                <Link to={`${pathurl}/loadunload/home`} onClick={(evt) => {
                    this.props.loadConfig(getVision(), ENUMS.eModules.LoadUnload.value);
                    this.closeMenu(evt);
                }}>
                    <i className="material-icons">local_shipping</i>
                    {this.translate('menu:load-unload')}
                </Link>)];
        }


        if (checkPermission(PERMISSIONS.Location.Access)) {
            menu = [...menu, (
                <Link to={`${pathurl}/warehousemanagement`} onClick={(evt) => {
                    this.props.loadConfigUser();
                    this.props.loadConfig(getVision(), ENUMS.eModules.Location.value);
                    this.closeMenu(evt);
                }}>
                    <i className="material-icons">edit_location</i>
                    {this.translate('menu:warehouse-management')}
                </Link>)];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Access)) {
            menu = [...menu, (
                <Link to={`${pathurl}/container`} onClick={(evt) => {
                    this.props.loadConfigUser();
                    this.props.loadConfig(getVision(), ENUMS.eModules.Location.value);
                    this.closeMenu(evt);
                }}>
                    <i className="material-icons">view_module</i>
                    {this.translate('menu:warehouse-container')}
                </Link>)];
        }
        if (checkPermission(PERMISSIONS.Config.Access) === true) {
            menu = [...menu, (
                <Link to={`${pathurl}/config`} onClick={(evt) => {
                    this.props.searchSheds(getVision());
                    this.closeMenu(evt);
                }}>
                    <i className="material-icons">settings</i>
                    {this.translate('menu:settings')}
                </Link>)];
        }

        menu = [...menu, (
            <Link to={`${pathurl}/logout`} onClick={() => {
                this.closeMenu();
                window.location.reload(true)
            }}>
                <i className="material-icons">exit_to_app</i>
                {this.translate('logout', 'menu')}
            </Link>)];

        this.setState({ menu });
    }

    componentDidMount() {
        if (this.props.isAuthenticated()) {
            this.sideInstance = M.Sidenav.init(this.sidenav, {
                edge: 'left',
                inDuration: process.env.REACT_APP_ANIMATION_TIMEOUT,
            });
            M.Collapsible.init(this.infoUser);
            setTimeout(() => {
                this.props.getUser();
                this.props.showLoading();
                this.props.setVision(getVision(), (result) => {
                    if (result.success === false) {
                        this.showMessageToastCustom(this.translate('warning', 'general'), this.translate('error-load-resource', 'menu'), 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    this.generateMenu();
                    this.generateQrcodeUser();
                    this.props.getUsersForValidate(getVision());
                });
            }, 1000);
        }
    }

    generateQrcodeUser = () => {
        QRCode.toCanvas(document.getElementById('qrcodeUser'), this.props.user.userName);
    }

    onChangeLanguage = (el) => {
        this.props.setCulture(el.target.value);
        this.changeLanguage(el.target.value);
    }

    onChangeVision = (el) => {
        this.props.showLoading();
        const value = el.target.value;
        const pathurl = getPathApp(window);
        this.setState({ menu: [] }, () => {
            this.props.setVision(value, (result) => {
                if (result.success === false) {
                    this.showMessageToastCustom(this.translate('warning', 'general'), this.translate('error-load-resource', 'menu'), 8000, 'mdi mdi-alert-circle-outline red-text');
                }
                this.props.resetInventory();
                this.generateMenu();
                this.props.getUsersForValidate(getVision());
                this.props.history.push(`${pathurl}/home`);
            });
        });
    }

    closeMenu = (e) => {
        if (this.isParametersValid() === true || e.target.href.indexOf('/logout') > -1) {
            setTimeout(() => {
                this.sideInstance.close();
            }, process.env.REACT_APP_CLOSE_MENU_TIMEOUT);
        } else {
            e.preventDefault();
        }
    }

    isParametersValid() {
        if (isNullOrEmpty(this.props.user.vision)) {
            this.showMessageToastCustom(this.translate('warning', 'general'), this.translate('select-vision', 'validations'), 8000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    formatVisions = (vision) => {
        if (vision === "Fiat Cordoba - 162 - Almacén 03") {
            return "Faasa - 162"
        }

        if (vision === "Fiat Cordoba - 162 - Almacén 18") {
            return "Faasa CKD - 162"
        } else {
            return vision;
        }
    }


    render() {
        return this.props.isAuthenticated() ? (
            <div>
                <ul id="slide-out" className="sidenav" ref={(sidenav) => this.sidenav = sidenav} style={{ zIndex: '99999' }}>
                    <li key="m-0">
                        <div className="user-view">
                            {/* <span><i className="medium material-icons">account_circle</i></span> */}
                            <span className="white-text name">{this.props.user.name}</span>
                            <ul className="collapsible" ref={(el) => { this.infoUser = el; }} style={{ paddingBottom: '2px' }}>
                                <li
                                    ref={(el) => this.liInforUser = el}
                                    style={{ lineHeight: '1', backgroundColor: 'transparent' }}
                                    className="center"
                                    onClick={() => {
                                        if (this.liInforUser.classList.contains('active') === true) {
                                            this.setState({ infoUserMenu: 'expand_less' });
                                        } else {
                                            this.setState({ infoUserMenu: 'expand_more' });
                                        }
                                    }}
                                >
                                    <div className="collapsible-header" style={{ backgroundColor: 'transparent', display: 'inline-block', marginLeft: 'auto', marginRight: 'auto' }}>
                                        <i className="material-icons" style={{ height: '20px' }}>{this.state.infoUserMenu}</i>
                                    </div>
                                    <div className="collapsible-body" style={{ backgroundColor: 'transparent' }}>
                                        <span className="white-text email" style={{ padding: '0' }}>{this.props.user.email}</span>
                                        <span className="white-text email" style={{ padding: '0' }}>{this.props.user.userName}</span>
                                        <span><canvas id="qrcodeUser" align="center" /></span>
                                    </div>
                                </li>
                            </ul>

                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="col s12">
                                <Select
                                    id="slUserVision"
                                    name="userVision"
                                    placeHolder={this.translate('menu:select-vision')}
                                    data={this.props.user.visions.map((i) => { return { id: i.Code, text: this.formatVisions(i.Name) }; })}
                                    defaultValue={this.props.user.vision}
                                    change={this.onChangeVision}
                                />
                            </div>
                        </div>
                    </li>
                    <li key="m-1"><div className="divider" /></li>
                    {this.state.menu.map((itemMenu, index) => {
                        return (
                            <li key={`m-${index + 2}`}>
                                {itemMenu}
                            </li>
                        );
                    })}
                </ul>
            </div>
        ) : null;
    }
}

export const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getUser: () => {
            dispatch(SecurityService.loadUser());
        },
        setVision: (vision, callback) => {
            dispatch(SecurityService.setVision(vision, callback));
        },
        setCulture: (culture) => {
            dispatch(SecurityService.setCulture(culture));
        },
        isAuthenticated: () => {
            return SecurityService.isAuthenticated();
        },
        checkPermission: (permission) => {
            return SecurityService.checkPermission(permission);
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        resetInventory: () => {
            dispatch(actionInventory.listInventories([]));
        },
        searchSheds: (vision) => {
            dispatch(PlantService.searchSheds(vision));
        },
        loadConfig: (vision, module) => {
            dispatch(SecurityService.loadConfig(vision, module));
        },
        loadConfigUser: () => {
            dispatch(SecurityService.loadConfigUser());
        },
        clearConfigurations: () => {
            dispatch(ConfigurationService.clearConfigurations());
        },
        clearPicking: () => {
            dispatch(pickingAction.resetFilter());
            dispatch(pickingAction.resetOrders());
            dispatch(pickingAction.resetOrder());
        },
        clearLinePicking: () => {
            dispatch(linePickingAction.resetFilter());
            dispatch(linePickingAction.resetOrderGroup());
            dispatch(linePickingAction.resetOrdesAll());
        },
        resetResourceShedDock: () => {
            dispatch(actionUser.resetResourceShedDock());
        },
        clearVolume: () => {
            dispatch(VolumeService.clear());
        },
        getUsersForValidate: (vision) => {
            dispatch(UserValidateService.getUsersElog(vision));
        },
        clearPrintSelect: () => {
            dispatch(PhysicalConfirmationService.clearPrintSelect());
        },
        getResourcesAll: (vision, filter) => {
            dispatch(ConfigurationService.getResourcesAll(vision, filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Menu)));
